export default __webpack_public_path__ + "static/media/icon-health-info.5fa99541.svg";